import {withExperimentOverrides} from '@wix/debug-panel';
import Experiments from '@wix/wix-experiments';

export function conductExperiments(scope) {
  if (scope === 'wix-music' && window.__EXPERIMENTS__) {
    return Promise.resolve(withExperimentOverrides(window.__EXPERIMENTS__));
  }
  const experiments = new Experiments(/* {baseUrl: '//www.wix.com'}*/);
  return experiments.load(scope).then(() => experiments.all());
}
